<template>
    <div>

        <div v-if="isLoading">
            <loader></loader>
        </div>

        <div v-if="!isLoading && availability">
            <div class="btn-container" v-if="availability.length > 1">
                <div class="date-selector"
                     v-for="(a, index) in availability.Availability">

                    <button v-on:click="selectedDateIndex = index"
                            v-bind:class="{'modal-button--active' : selectedDateIndex == index}"
                            class="btn modal-button ">
                        <span class="top">
                            {{formatDateTop(a.Date)}}
                        </span>
                        <span class="bottom">
                            {{formatDateBottom(a.Date)}}

                        </span>
                    </button>
                </div>
            </div>

            <h3>Tee-off time</h3>
            <div v-for="(aa, index) in availability">
                <div v-for="(a, index) in aa.Availability">


                    <div class="row " v-if="selectedDateIndex==index">

                        <div class="col-md-24 ">
                            <div class="row mb-4">
                                <div class="col-md-12">
                                    <button class="btn btn--block modal-button"
                                            v-bind:class="{'modal-button--active' : (a.timeOfDay=='AM') ||  (a.timeOfDay == undefined && defaultTimeOfDay == 'AM')}"
                                            v-on:click="onSetTimeOfDay(a, 'AM')">
                                        Morning
                                    </button>
                                </div>
                                <div class="col-md-12">
                                    <button class="btn btn--block modal-button"
                                            v-bind:class="{'modal-button--active' : (a.timeOfDay=='PM') || (a.timeOfDay == undefined && defaultTimeOfDay == 'PM')}"
                                            v-on:click="onSetTimeOfDay(a, 'PM')">
                                        Afternoon
                                    </button>
                                </div>
                            </div>

                            <div class="row" v-if="a.timeOfDay=='AM' || (a.timeOfDay == undefined && defaultTimeOfDay == 'AM')">
                                <span class="col-12 col-md-6 col-xl-4" v-for="t in a.AM">
                                    <span class="time-slot"
                                          v-bind:class="{'time-slot--active': isSelected(a, t), 'timeslot--disabled' : checkIsDisabled(t)}"
                                          v-on:click="onSelection(a, t)">

                                        {{formatTime(t.DateTime)}}

                                    </span>
                                </span>
                            </div>

                            <div class="row" v-if="a.timeOfDay==='PM' || (a.timeOfDay == undefined && defaultTimeOfDay == 'PM')">
                                <span class="col-12 col-md-6 col-xl-4" v-for="t in a.PM">
                                    <span class="time-slot"
                                          v-bind:class="{'time-slot--active': isSelected(a, t), 'timeslot--disabled' : checkIsDisabled(t)}"
                                          v-on:click="onSelection(a, t)">

                                        {{formatTime(t.DateTime)}}

                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>

<script>

    import { store } from '../store/index';
    import Loader from '@/shared/components/Loader.vue';

    export default {
        name: 'GolfAvailability',
        props: {
            room: {
                type: Object,
                required: true
            }
        },
        components: {
            Loader
        },
        computed: {
            session() {
                return store.getters.session;
            },
            booking() {
                return store.getters.booking;
            },
            availability() {
                return store.getters.golfAvailability;
            }
        },
        data() {
            return {
                isLoading: false,
                defaultTimeOfDay: 'AM',
                selectedDateIndex: 0,
                localGolf: []
            }
        },
        mounted() {

            if (this.availability == null) {
                this.isLoading = true;

                var payload = {
                    sessionId: this.session.Id,
                    startDate: this.booking.arrivalDate,
                    numberOfDays: this.booking.numberOfNights,
                    rounds: [
                        {
                            number: 1,
                            players: this.room.guestQuota.Adults
                        }]
                }
                store.dispatch('fetchGolfAvailability', payload)
                    .then(() => {

                        this.isLoading = false;
                    })
            }



        },
        methods: {
            checkIsDisabled(t) {
                if (t.Item == null) {
                    return true;
                }

                for (let ri = 0; ri < this.localGolf; ri++) {
                    let round = this.search.rounds[ri];
                    if (round.Time == t) {
                        return true;
                    }
                }


                return false;
            },
            isSelected(a, t) {
                var existingItem = this.localGolf.find(item => item.Date == a.Date && item.Time == t);
                return existingItem != null;t
            },
            onSetTimeOfDay(a, timeOfDay) {

                a.timeOfDay = timeOfDay;
            },
            onSelection(a, t) {
                var existingItem = this.localGolf.find(item => item.Date == a.Date);
                if (existingItem != null) {
                    this.localGolf.pop(existingItem);
                }

                var item = {
                    Date: a.Date,
                    Time: t
                }
                this.localGolf.push(item)

                var payload = {
                    leg: this.room.leg,
                    selection: this.localGolf
                }

                store.dispatch("selectGolf", payload);
            },
            formatDateTop(input) {
                let date = moment(input);
                return date.format("ddd Do");
            },
            formatDateBottom(input) {

                let date = moment(input);
                return date.format("MMM YY");
            },
            formatTime(dateTime) {

                let date = moment(dateTime);
                return date.format("HH:mm");
            }
        }
    }
</script>

<style>
    .time-slot {
        padding: 15px;
        display: block;
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;
    }


        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 0.15);
            cursor: not-allowed;
        }


        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }


    .date-selector {
        font-size: 14px;
        font-family: Montserrat;
    }

    .modal-button {
        background-color: #fff;
        position: relative;
        color: #000;
        border-color: #fff;
        margin-bottom: 30px !important;
    }


        .modal-button:after {
            border-top: 10px solid #fff;
            display: block;
            position: absolute;
            content: ' ';
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            z-index: 10;
        }



    .modal-botton:hover,
    .modal-button--active {
        background-color: #425260;
        border-color: #425260;
        color: #fff;
    }

        .modal-botton:hover,
        .modal-button--active:after {
            border-top: 10px solid #425260;
        }

    .date-selector {
        margin-right: 20px;
    }

        .date-selector:last-of-type {
            margin-right: 0;
        }

        .date-selector button {
            width: 160px;
            padding: 20px;
            margin-right: 20px;
        }



        .date-selector .top {
            font-weight: bold;
            display: block;
        }

        .date-selector .bottom {
            font-weight: 300;
            display: block;
        }
</style>